var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-base",
    {
      attrs: {
        overlap: _vm.overlap,
        small: _vm.small,
        transparent: _vm.transparent,
        stretched: _vm.stretched,
        slimmer: _vm.slimmer
      }
    },
    [
      !_vm.noLabel
        ? _c(
            "label",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _c("q-icon", {
                staticClass: "label-icon d-box d-md-none",
                attrs: {
                  allowSelfUpdate: false,
                  width: "11.5px",
                  name: "calendar"
                }
              }),
              _vm._v(" "),
              !!_vm.inputLabel
                ? _c("label", { attrs: { for: _vm.inputName } }, [
                    _vm._v("\n\n      " + _vm._s(_vm.inputLabel) + "\n    ")
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "icon-input", attrs: { slot: "input" }, slot: "input" },
        [
          _c("time-picker", {
            class: _vm.getInnerStyle,
            attrs: { name: _vm.inputName, format: "hh:mm A" },
            model: {
              value: _vm.time,
              callback: function($$v) {
                _vm.time = $$v
              },
              expression: "time"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b852e50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b852e50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputTime.vue
// module id = null
// module chunks = 